<template>
<div class="animated fadeIn">
    <b-row>
        <b-col sm="12">
            <b-card>
                <div slot="header">
                    <strong>{{title}}</strong>
                </div>
                <b-row>
                    <b-col sm="4">
                        <b-form-group>
                            <label>SRF Date</label>
                                <b-form-input type="date" v-model="srf.srf_date" :disabled="lockEntry"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                        <b-form-group>
                            <label>Requestor</label>
                                <employeeLookup v-bind:url="apiEmployeeLookup" v-on:selected="setEmployee($event)" :lookupId="srf.requestor_user_id" :disabled="lockEntry" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                            <label for="location_id">Location From (Warehouse)</label>
                            <warehouseLookup v-bind:url="apiWarehouseUrl" v-on:selected="setWarehouse($event)" :lookupId="srf.location_id" :disabled="lockEntry" />
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                        <b-form-group>
                            <label>Event Start Date</label>
                                <b-form-input type="date" v-model="srf.event_start_date" :disabled="lockEntry"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="4">
                            <b-form-group>
                                <label>Event End Date</label>
                                    <b-form-input type="date" v-model="srf.event_end_date" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                    </b-col>
                    <b-col sm="4">
                            <b-form-group>
                                <label>Reference No</label>
                                <b-form-input type="text" v-model="srf.reference_num" :disabled="lockEntry"></b-form-input>
                            </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4">
                            <b-form-group>
                                <label>Reason</label>
                                <b-form-select id="reason" v-model="srf.reason"
                                               :disabled="lockEntry"
                                               :plain="true"
                                               :options="srf_reason_list_items"></b-form-select>
                            </b-form-group>
                    </b-col>
                    <b-col sm="4">
                            <b-form-group>
                                    <label>Returning Type</label>
                                    <b-form-select id="returning_type" v-model="srf.returning_type"
                                        :plain="true"
                                        :options="['RETURNABLE','NON RETURNABLE']"
                                        :disabled="lockEntry"
                                        >
                                    </b-form-select>
                            </b-form-group>
                    </b-col>
                    <b-col sm="4">
                            <b-form-group>
                                <label>Return Date</label>
                                    <b-form-input type="date" :value="returnDate" disabled></b-form-input>
                            </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <label for="remarks">Remarks</label>
                            <textarea class="form-control" rows="5" id="remarks" v-model="srf.remarks" :disabled="lockEntry"></textarea>
                    </b-col>
                </b-row>

                <b-row v-if="srf.status == 'CLOSED'" class="mt-2 p-2">
                  <b-col sm="3" class="bg-info p-2">
                    <span>Closed by: {{ srf.closed_by_user_id }}</span><br>
                    <span>Closed at: {{ srf.closed_at }}</span><br>
                  </b-col>
                </b-row>

                <b-row v-if="srf.approval_status == 'APPROVED'" class="mt-2 p-2">
                  <b-col sm="3" class="bg-success p-2">
                    <span>Approved by: {{ srf.approver_user_id }}</span><br>
                    <span>Approved at: {{ srf.approved_at }}</span>
                  </b-col>
                </b-row>

                <b-row v-if="srf.approval_status == 'REJECTED'" class="mt-2 p-2">
                  <b-col sm="3" class="bg-danger p-2">
                    <span>Rejected by: {{ srf.rejecter_user_id }}</span><br>
                    <span>Rejected at: {{ srf.rejected_at }}</span><br>
                    <span>Reason: {{ srf.rejected_reason }}</span>
                  </b-col>
                </b-row>
              </b-row>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="srf.location_id != '' && !noItemsFound || lockEntry">
        <b-col sm="12">
            <b-card>
                <div slot ="header">
                    <strong>SRF Items</strong>
                </div>
                <b-row v-if="0">
                    <b-col sm="2">
                        <label>SRF No</label>
                            <b-form-input type="text" id="total_amount" v-model="srf.amount_total"></b-form-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <div class="table-responsive">
                            <table class='table table-striped table-bordered'>
                                <thead>
                                    <th style="width:10px">S/N</th>
                                    <th style="min-width:300px">Product Name</th>
                                    <th width="230px">Product Code</th>
                                    <th width="150px">SOH</th>
                                    <th width="250px">SRF Qty</th>
                                    <th width="180px">Unit GMP ({{srf.currency_id}})</th>
                                    <th width="180px">Total GMP ({{srf.currency_id}})</th>
                                    <th width="30px"></th>
                                </thead>
                                <tbody>
                                    <tr v-for="row, index in srf.srf_items" >
                                        <td>{{(index*1) + 1}}</td>
                                        <td>
                                            <productLookup v-bind:url="apiLocationProductUrl" v-on:selected="setProduct($event, index)" :lookupId="row.product_id" :q2="srf.location_id" :disabled="lockEntry"/>
                                        </td>
                                        <td >{{row.product_id}}</td>
                                        <td v-if="!lockEntry">{{row.qty_soh*1 - row.qty*1}}</td>
                                        <td v-if="lockEntry">{{row.qty_soh*1}}</td>
                                        <td><input type="number" min="0" name="qty" v-model="row.qty" class="form-control" :disabled="lockEntry" @change = "validateQty(index)"/></td>
                                        <td>{{row.unit_gmp}}</td>
                                        <td>{{((row.qty * 1) * (row.unit_gmp * 1)).toFixed(2)}}</td>
                                        <td><a href="#" @click="removeRow(index)" tabindex="-1" v-if="!lockEntry"><i class='fa fa-trash' style="font-size:25px;color:red;" v-if="!lockEntry"></i></a></td>
                                    </tr>
                                    <tr>
                                        <td colspan=8>
                                            <b-button type="submit" size="md" variant="success" @click="addRow" v-if="!lockEntry">Add Product</b-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
    <b-row v-if="srf.location_id != '' && !noItemsFound || lockEntry">
            <b-col sm="12">
                <b-row style="padding: 0px 0px 20px 18px;">
                        <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="!lockEntry">Save SRF</b-button>
                        <b-modal v-model="modalShow" @ok="save" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                                <p style="color:darkblue">Confirmed Save SRF?</p>
                        </b-modal>
                        <b-modal v-model="modalCancelShow" @ok="cancel" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                                <p style="color:darkblue">Confirmed Cancel?</p>
                        </b-modal>
                            <b-modal ref="myModalRef" hide-header-close hide-footer title="Stock Requisition Form" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                                <div class="d-block text-center">
                                        <p>Stock Requisition Form<strong style="color:green"> {{srfDocNo}}</strong> is saved.<br/><br/></p>
                                </div>
                                    <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
                            </b-modal>
                                <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                                    <div class="d-block text-center">
                                        <p style="color:red">{{errorMessage}}</p>
                                    </div>
                                    <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
                            </b-modal>
                            <b-modal v-model="modalErrorShow" title="Error"  centered header-bg-variant="success" no-close-on-backdrop>
                                <p style="color:darkblue">{{errorMessage}}</p>
                            </b-modal>
                             &nbsp;
                        <b-button type="submit" size="lg" variant="danger" @click="confirmCancel" v-if="!lockEntry">Cancel</b-button>
                        <b-button type="submit" size="lg" variant="primary" @click="confirmClose" v-if="btnVisible && srf.status != 'CLOSED' ">Close</b-button>&nbsp;
                        <b-modal v-model="closeModalShow" @ok="close" title="Close"  centered header-bg-variant="success" no-close-on-backdrop>
                          <p style="color:darkblue">Confirmed Close SRF?</p>
                        </b-modal>
                        <b-button type="submit" size="lg" variant="primary" @click="confirmApprove" v-if="btnVisible && srf.status != 'CLOSED' && srf.approval_status == 'NEW' ">Approve</b-button>&nbsp;
                        <b-modal v-model="approveModalShow" @ok="approve" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                          <p style="color:darkblue">Confirmed Approve SRF?</p>
                        </b-modal>
                        <b-button type="button" size="lg" variant="danger" @click="confirmReject" v-if="btnVisible && srf.status != 'CLOSED' && srf.approval_status == 'NEW'">Reject</b-button>&nbsp;
                        <b-modal id="modalPrevent" ref="rejectModal" title="Reject SRF?" centered @ok="reject">
                          <form @submit.stop.prevent="handleSubmit">
                            <b-form-input type="text" placeholder="Enter the reason" v-model="srf.rejected_reason"></b-form-input>
                          </form>
                        </b-modal>
                        <b-button type="submit" size="lg" variant="success" @click="print" v-if="lockEntry">Print</b-button>&nbsp;
                        <b-button type="submit" size="lg" variant="danger" @click="back" v-if="lockEntry">Back</b-button>
                        <b-modal ref="msgBox" hide-header-close hide-footer :title="mbTitle" centered header-bg-variant="primary" no-close-on-backdrop no-close-on-esc>
                          <div class="d-block text-center">
                            <p style="color:green">{{mbMsg}}</p>
                          </div>
                          <b-btn class="float-right" variant="danger" @click="$refs.msgBox.hide()">OK</b-btn>
                        </b-modal>
                </b-row>
            </b-col>
    </b-row>
    <b-row  v-if="srf.location_id != '' && noItemsFound && !lockEntry">
        <b-col sm="12">
            <div align="center">
                <strong style="color:red">No Products Found in the Selected Warehouse! Please Select a Different Warehouse</strong>
            </div>
        </b-col>
    </b-row>
</div>
</template>
<script>
import axios from 'axios'
import warehouseLookup from '@/components/Autocomplete.vue'
import productLookup from '@/components/Autocomplete.vue'
import employeeLookup from '@/components/Autocomplete.vue'
import {apiSrfSearch, apiEmployeeLookup, authHeader, apiWarehouseLookup, apiLocationProductUrl, apiSrfSave, apiSrfGet, apiCountryLookup, apiSrfClose, apiSrfApprove, apiReasonLookup} from '@/functions/common.vue'
import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
export default
{
    components:{employeeLookup, warehouseLookup,productLookup},
    data: () => {
        return {
            isWh: false,
            isWhHoo: false,
            isAcc: false,
            isAccFn: false,
            btnVisible: false,
            closeModalShow: false,
            approveModalShow: false,
            title:'New SRF',
            apiWarehouseUrl:apiWarehouseLookup,
            apiLocationProductUrl:apiLocationProductUrl,
            apiEmployeeLookup:apiEmployeeLookup,
            apiReasonLookup:apiReasonLookup,
            countryId:'',
            country_name:'',
            srf_ref: '',
            lockEntry:false,
            modalShow:false,
            modalCancelShow:false,
            showItemsTable:false,
            srfDocNo:'',
            modalErrorShow:false,
            prevWhID:'',
            errorMessage:'',
            noItemsFound:true,
            srf_reason_list_items: [],
            srf :
            {
                requested_date:'',
                location_id:'',
                requestor_user_id: '',
                reference_num:'',
                event_start_date:'',
                event_end_date:'',
                return_date:'',
                returning_type:'NON RETURNABLE',
                reason:'',
                remarks:'',
                amount_total:'',
                currency_id:'',
                status:'',
                approval_status:'',
                rejected_reason:'',
                rejecter_user_id:'',
                rejected_at:'',
                approver_user_id:'',
                approved_at:'',
                closed_by_user_id:'',
                closed_at:'',
                srf_items: [
                  {product_name:'', product_id:'', qty_soh:'', qty:'',unit_gmp:'',amount_total:''}
                ]
            }
        }
    },
    computed:
    {
        returnDate()
        {
          var date = ''
          if(this.srf.returning_type != 'NON RETURNABLE')
          {
              if(this.srf.event_end_date !='')
              {
                var event_end_date = this.srf.event_end_date
                var date = new Date(Date.parse(event_end_date) + 12096e5);
                date = date.toISOString().substr(0,10)
              }
          }
          this.srf.return_date = date
          return date
        },
    },
    created()
    {
        var app_role

        app_role = JSON.parse(localStorage.getItem("app_role"))
        this.isWh = app_role.includes("WH")
        this.isWhHoo = app_role.includes("WH_HOO")
        this.isAcc = app_role.includes("AC")
        this.isAccFn = app_role.includes("AC_FN")

        this.srf_ref = this.$route.params.srfNum
        if(this.srf_ref == '_new')
        {
            let curDate = new Date()
            curDate = curDate.toISOString().substr(0,10)
            this.srf.srf_date = curDate
            this.lockEntry = false
            this.noItemsFound = true
        }
        else
        {
            this.lockEntry = true
            this.noItemsFound = false
            this.fetch(this.srf_ref)
        }

        axios.get(apiReasonLookup, {params: {module: 'srf'}}, authHeader())
          .then (res => {
            if (res.data.code == 1) {
              res.data.data.forEach((item, index) => {
                this.srf_reason_list_items.push(item.description)
              });
            }
          })
          .catch(error => alert(error))
    },
    methods:
    {
        print()
        {
            console.log(this.srf.return_date)
                    var srf_num = this.srf.srf_num
                    var row = []
                    var date = new Date(this.srf.srf_date)
                    var srfDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    var srfItems = []
                    var returnDate = '-'
                    var rd = this.returnDate
                    if(rd != '')
                    {
                        var d = new Date(this.srf.return_date)
                        returnDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + ((d.getMonth() + 1) > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear()
                    }
                    row = [
                        {
                            text: 'S/No',
                            style: 'itemsHeader'
                        },
                        {
                            text: 'Product Code',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Description',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'SOH',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Unit GMP',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                        {
                            text: 'Qty',
                            style: ['itemsHeader'],
                            alignment: 'right'
                        },
                        {
                            text: 'Total GMP',
                            style: ['itemsHeader'],
                            alignment: 'left'
                        },
                    ]
                    srfItems.push(row)
                    var items = this.srf.srf_items
                    for (let key in items)
                    {
                        var data = items[key]
                        var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var unit_gmp = (data.unit_gmp* 1).toFixed(2)
                        unit_gmp=unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        var amount_total = (data.amount_total* 1).toFixed(2)
                        amount_total = amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        if (data.product_name == null)
                        {
                            data.product_name = ""
                        }
                        row = [
                            {
                                text: (key * 1) + 1,
                                style: 'itemText'
                            },
                            {
                                text: data.product_id,
                                style: 'itemText'
                            },
                            {
                                text: data.product_name,
                                style: 'itemText'
                            },
                            {
                                text: soh,
                                style: 'itemText'
                            },
                            {
                                text: unit_gmp,
                                style: 'itemText'
                            },
                            {
                                text: qty,
                                style: 'itemNumber'
                            },
                            {
                                text: amount_total,
                                style: 'itemText'
                            },
                        ]
                        srfItems.push(row)
                    }

                    var ddHeader = {
                        columns: [
                            [{
                                    text: 'ELKEN ' + this.country_name + ' STOCK REQUISITION FORM',
                                    style: 'invoiceTitle',
                                    width: '*'
                                },
                                {
                                    stack: [{
                                            columns: [
                                                {
                                                    text: 'SRF #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: srf_num,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'SRF Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: srfDate,
                                                    style: 'invoiceSubValue',
                                                    width: 100

                                                },
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Requestor',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.requestor_user_shortname,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Stock Location',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.location_full,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },
                                            ]

                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Event Start Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.event_start_date,
                                                    style: 'invoiceSubValue',
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Event End Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.event_end_date,
                                                    style: 'invoiceSubValue',
                                                    width: 100
                                                },

                                            ]

                                        },
                                        {
                                            columns:
                                            [
                                                {
                                                    text: 'Reference #',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.reference_num,
                                                    style: 'invoiceSubValue',
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Reason',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.reason,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Returning Type',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.returning_type,
                                                    style: 'invoiceSubValue',
                                                },
                                                {text: '',style:'invoiceSubValue',width: 80},
                                                {
                                                    text: 'Return Date',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: returnDate,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                        {
                                            columns: [
                                                {
                                                    text: 'Currency Code',
                                                    style: 'invoiceSubTitle',
                                                    width: 95

                                                },
                                                {
                                                    text: this.srf.currency_id,
                                                    style: 'invoiceSubValue',
                                                },
                                            ]
                                        },
                                    ]
                                }
                            ],
                        ],
                    }

                    var dd = {
                        header: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 10, 0, 0],
                                columns: [{
                                        text: '',
                                        style: 'documentHeaderLeft'
                                    },
                                    {
                                        text: srf_num,
                                        style: 'documentHeaderCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentHeaderRight'
                                    }
                                ]
                            }
                        },
                        footer: function (pageNumber, pageCount) {
                            return {
                                margin: [0, 0, 0, 50],
                                columns: [{
                                        text: '',
                                        style: 'documentFooterLeft'
                                    },
                                    {
                                        text: 'Page ' + pageNumber + " of " + pageCount,
                                        style: 'documentFooterCenter'
                                    },
                                    {
                                        text: '',
                                        style: 'documentFooterRight'
                                    }
                                ]
                            };
                        },
                        content: [
                            ddHeader,
                            // Line breaks
                            '\n\n',
                            {
                                layout: 'lightHorizontalLines',
                                table: {

                                    headerRows: 1,
                                    widths: [25, 'auto', '*', 'auto', 'auto','auto','auto'],
                                    body: srfItems

                                }, // table
                            },
                            {
                                text: 'Remarks',
                                style: 'notesTitle'
                            },
                            {
                                text: this.srf.remarks,
                                style: 'notesText'
                            },
                            {
                                columns: [
                                        {
                                            stack: [
                                                {
                                                    text: 'Issued By',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: 'Name  : '+this.srf.author_user_shortname,
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: 'Date  : ' + srfDate,
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 160
                                        },
                                        {
                                            stack: [
                                                {
                                                    text: '  ',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '                      ',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: '  ',
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: '      ',
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 180
                                        },
                                        {
                                            stack: [
                                                {
                                                    text: 'Received By',
                                                    style:'signaturePlaceholder'
                                                },

                                                {
                                                    text: '______________________________',
                                                    style:'signaturePlaceholder'
                                                },
                                                {
                                                    text: 'Name  :',
                                                    style:'signatureName'

                                                },
                                                {
                                                    text: 'Date  :',
                                                    style:'signatureJobTitle'

                                                }
                                                ],
                                                width: 160
                                        }

                                    ]
                        },
                        ],
                        styles: {
                            // Document Header
                            documentHeaderLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentHeaderCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentHeaderRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Document Footer
                            documentFooterLeft: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'left'
                            },
                            documentFooterCenter: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'center'
                            },
                            documentFooterRight: {
                                fontSize: 10,
                                margin: [5, 5, 5, 5],
                                alignment: 'right'
                            },
                            // Invoice Title
                            invoiceTitle: {
                                fontSize: 22,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 0, 0, 15]
                            },
                            // Invoice Details
                            invoiceSubTitle: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            invoiceSubValue: {
                                fontSize: 10,
                                alignment: 'left'
                            },
                            // Billing Headers
                            invoiceBillingTitle: {
                                fontSize: 14,
                                bold: true,
                                alignment: 'left',
                                margin: [0, 20, 0, 5],
                            },
                            // Billing Details
                            invoiceBillingDetails: {
                                alignment: 'left'

                            },
                            invoiceBillingAddressTitle: {
                                margin: [0, 7, 0, 3],
                                bold: true
                            },
                            invoiceBillingAddress: {

                            },
                            // Items Header
                            itemsHeader: {

                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true
                            },
                            // Item Title
                            itemTitle: {
                                bold: true,
                            },
                            itemSubTitle: {
                                //italics: true,
                                fontSize: 10
                            },
                            itemText: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'left',
                            },
                            itemNumber: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                alignment: 'right',
                            },
                            itemTotal: {
                                fontSize: 10,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },

                            // Items Footer (Subtotal, Total, Tax, etc)
                            itemsFooterSubTitle: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterSubValue: {
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            itemsFooterTotalTitle: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'right',
                            },
                            itemsFooterTotalValue: {
                                fontSize: 11,
                                margin: [0, 5, 0, 5],
                                bold: true,
                                alignment: 'center',
                            },
                            signaturePlaceholder: {
                                fontSize: 10,
                                margin: [0, 70, 0, 0],
                            },
                            signatureName: {
                                fontSize: 10,
                                margin: [0, 10, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            signatureJobTitle: {
                                fontSize: 10,
                                margin: [0, 20, 0, 0],
                                bold: true,
                                alignment: 'left',
                            },
                            notesTitle: {
                                fontSize: 10,
                                bold: true,
                                margin: [0, 30, 0, 3],
                            },
                            notesText: {
                                fontSize: 10
                            },
                            center: {
                                alignment: 'center',
                            },
                        },
                        defaultStyle: {
                            columnGap: 20,
                            font:'ukai'
                        }
                    }
                    pdfMake.createPdf(dd).open();
                },
        back()
        {
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)'})
        },
        fetch(docNum)
        {
            this.lockEntry = true
            var sf =
            [
                "srf_num = " + docNum
            ]
            axios.post(apiSrfSearch,sf,authHeader())
              .then (res => {
                var data
                data = res.data.data.list[0]
                this.srf = data
                this.title = "Stock Requisition Form (" + data.srf_num + ")"
                if (this.srf.country_id != null) {
                    axios.get(apiCountryLookup, {params: {q: this.srf.country_id}})
                      .then(response => {
                          if (response.data != null) {
                              this.list = response.data.data.list
                              this.item = this.list[0]
                              this.country_name = this.item.country_name
                              this.country_name = this.country_name.toUpperCase()
                          }
                      })
                }
                this.countryId = data.country_id
                this.status = data.status

                if (this.isAccFn) {
                  this.btnVisible = true
                } else if (this.isWhHoo) {
                  if (this.lockEntry) {
                    this.btnVisible = true
                  }
                }
            })
            .catch(error => alert(error)
            )
        },
        setEmployee(obj)
        {
            if (!this.lockEntry)
            {
                var id

                if (obj !== null)
                {
                    id = obj.id
                }
                else
                {
                    id = null
                }
                this.srf.requestor_user_id = id
            }
        },
        setWarehouse(obj)
        {
            if (!this.lockEntry)
            {
                var id
                var curr_id

                if (obj !== null)
                {
                    if (obj.id != this.srf.location_id)
                    {
                        id = obj.id
                        curr_id = obj.currency_id
                        this.srf.srf_items = []
                        this.srf.location_id = id
                        this.srf.currency_id = curr_id
                        if (this.srf.location_id != '')
                        {
                            axios.get(apiLocationProductUrl,{params: {q:'', q2: id}},authHeader())
                                .then (res => {
                                    var list
                                    list = res.data.data.list
                                    this.noItemsFound = (list.length == 0)
                                })
                                .catch(error => alert(error))
                        }

                    }
                }
                else
                {
                    id = ""
                    this.noItemsFound = true
                }
            }
        },
        setProduct(obj, index)
        {
            if (!this.lockEntry)
            {
                this.prevWhId = this.srf.location_id
                var name, id, qty_soh, unit_gmp
                var isDuplicatedEntry = false
                var items = this.srf.srf_items

                for(let n = 0; n < items.length; n++)
                {
                    if (n != index)
                    {
                        if (items[n].product_id == items[index].product_id && items[index].product_id != "")
                        {
                            isDuplicatedEntry = true
                        }

                        if (isDuplicatedEntry)
                            break;
                    }
                }

                if (!isDuplicatedEntry)
                {
                    if(obj !== null)
                    {
                        if (obj.id == "")
                        {
                            qty_soh = ""
                            unit_gmp = ""
                        }
                        else
                        {
                            name = obj.name
                            id = obj.id
                            qty_soh = obj.qty_soh
                            unit_gmp = obj.unit_gmp
                        }
                    }
                    else
                    {
                        name = ""
                        id = ""
                        qty_soh = ""
                        unit_gmp=""

                    }

                    if (isNaN(qty_soh))
                    qty_soh = ""
                }
                else
                {
                    name = ""
                    id = ""
                    qty_soh = ""
                    unit_gmp=""
                }

                this.srf.srf_items[index].product_id = id
                this.srf.srf_items[index].product_name = name
                this.srf.srf_items[index].qty_soh = qty_soh
                this.srf.srf_items[index].unit_gmp = unit_gmp
            }
        },
        addRow ()
        {
            this.srf.srf_items.push({product_id:'', product_name:'', qty_soh:'', qty:'',unit_gmp:'',total_gmp:''});
        },
        removeRow (index)
        {
            this.srf.srf_items.splice(index, 1);
        },
        confirmSave()
        {
            this.modalShow = true
        },
        save()
        {
            var srf_date = this.srf.srf_date
            var tday = new Date();
            var dd = tday.getDate();
            var mm = tday.getMonth()+1; //January is 0!
            var yyyy = tday.getFullYear();

            if(dd<10)
            {
                dd='0'+dd;
            }
            if(mm<10)
            {
                mm='0'+mm;
            }
            var tday = yyyy+'-'+mm+'-'+dd;

            if(this.srf.srf_date >= tday)
            {
                    if (this.srf.event_start_date != '' && this.srf.event_end_date != '')
                    {
                        var check = 1;
                        var start_date = this.srf.event_start_date
                        var end_date = this.srf.event_end_date
                        var today = new Date();
                        var dd = today.getDate();
                        var mm = today.getMonth()+1; //January is 0!
                        var yyyy = today.getFullYear();
                        if(dd<10){
                        dd='0'+dd;
                        }
                        if(mm<10){
                        mm='0'+mm;
                        }
                        var today = yyyy+'-'+mm+'-'+dd;

                        if (start_date >= today && end_date >= today)
                        {
                            axios.post(apiSrfSave, this.srf, authHeader())
                            .then (res =>
                            {
                                var r = res.data
                                if (r.code == 1)
                                {
                                    this.srfDocNo = r.data.srf_num
                                    this.$refs.myModalRef.show()
                                }
                                else
                                {
                                    this.errorMessage = r.msg
                                    this.$refs.myErrorModalRef.show()
                                }
                            }
                        )
                        .catch(error => {
                        alert("System Error")

                        })
                    }
                    else
                    {
                        this.errorMessage = "Post Dated date entry not allowed for event start date / event end date"
                        this.$refs.myErrorModalRef.show()
                    }
                }
                else
                {
                    this.errorMessage = "Invalid entry in event start date / event end date"
                    this.$refs.myErrorModalRef.show()
                }
            }
            else
            {
                this.errorMessage = "Post Dated date entry not allowed for SRF date"
                this.$refs.myErrorModalRef.show()
            }

        },
        confirmCancel()
        {
            this.modalCancelShow = true
        },
        cancel()
        {
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)'})
        },
        hideModal ()
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        showErrorModal(errorMessage)
        {
            this.errorMessage = errorMessage
            this.$refs.myErrorModalRef.show()
        },
        validateQty(index)
        {
            if(!this.lockEntry && 0)
            {
                var item = this.srf.srf_items[index];
                if(!isNaN(item.qty))
                {
                    if(item.qty < 0 )
                    {
                        item.qty =0
                    }
                    else if((item.qty * 1) > (item.qty_soh *1))
                    {
                        item.qty = 0
                    }
                }
                else
                {
                    item.qty = 0
                }
            }
        },
        close()
        {
          if (this.isWhHoo || this.isAccFn) {
            axios.post(apiSrfClose, {srf_num: this.srf.srf_num},authHeader())
              .then (res => {
                this.srf.status = "CLOSED"
                this.mbTitle = "Close"
                this.mbMsg = "SRF " + this.srf.srf_num + " has been closed."
                this.$refs.msgBox.show()
                this.fetch(this.srf_ref)
              })
              .catch(error => alert(error))
          }
        },
        confirmClose()
        {
          this.closeModalShow = true
        },
        approve()
        {
          if (this.isWhHoo) {
            axios.post(apiSrfApprove, {srf_num: this.srf.srf_num, approve: 1, reason: ''},authHeader())
              .then (res => {
                this.srf.approval_status = "APPROVED"
                this.mbTitle = "Approve"
                this.mbMsg = "SRF " + this.srf.srf_num + " has been approved."
                this.$refs.msgBox.show()
                this.fetch(this.srf_ref)
              })
              .catch(error => alert(error))
          } else if (this.isAccFn) {
            axios.post(apiSrfApprove, {srf_num: this.srf.srf_num, approve: 1},authHeader())
              .then (res => {
                this.srf.approval_status = "APPROVED"
                this.mbTitle = "Approve"
                this.mbMsg = "SRF " + this.srf.srf_num + " has been approved."
                this.$refs.msgBox.show()
                this.fetch(this.srf_ref)
              })
              .catch(error => alert(error))
          }
        },
        confirmApprove()
        {
          this.approveModalShow = true
        },
        reject()
        {
          this.$refs.rejectModal.hide()
          if (this.srf.rejected_reason != '' && this.srf.rejected_reason != null)
          {
            axios.post(apiSrfApprove, {srf_num: this.srf.srf_num, approve: 0, reason: this.srf.rejected_reason},authHeader())
              .then (res => {
                if (res.data.code == 1) {
                  this.srf.approval_status = "REJECTED"
                  this.mbTitle = "Reject"
                  this.mbMsg = "SRF " + this.srf.srf_num + " has been rejected."
                  this.$refs.msgBox.show()
                  this.fetch(this.srf_ref)
                }
              })
              .catch(error => alert(error))
          }
          else
          {
            this.mbTitle = "Manual Close cancelled"
            this.mbMsg = "Reason has to be provided"
            this.$refs.msgBox.show()
          }
        },
        confirmReject()
        {
          this.$refs.rejectModal.show()
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/srf/srf.vue